const germanPageData = {
  slug: 'german',
  code: 'de',
  name: 'German',
  nativeName: 'Deutsch',
  flag: '🇩🇪',
  accent: 'from-slate-700 to-amber-500',
  description: 'Summary notes and quick references for German learners.',
  notes: { summary: [], keyPoints: [], quickReference: [] },
};

export default germanPageData;
